import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { AuthService } from 'src/app/services/http-services/authservice.service';
import { AuthLayoutRoutes } from 'src/app/services/navigation-services/auth-layout-routes.service';
import { CustomLayoutRoutes } from 'src/app/services/navigation-services/custom-layout-routes.service';

@Component( {
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: [ './reset-password.component.css' ]
} )
export class ResetPasswordComponent implements OnInit, OnDestroy {
  alert: string;
  isError: boolean;
  isExternalToken: boolean;
  externalToken: string;
  resetForm = new FormGroup(
    {
      password: new FormControl( '', [ Validators.required, Validators.minLength( 8 ),
        //Validators.pattern( "^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$" )
      ] ),
      confirmPassword: new FormControl( '', [ Validators.required, this.matchValidator( 'password', 'confirmPassword' ) ] ),
    },
    [ this.matchValidator( 'confirmPassword', 'password' ) ]
  );
  errorSubscription: any;

  constructor ( private auth: AuthService, private errorEvent: EventService, private authroute: AuthLayoutRoutes, private activatedRoutes: ActivatedRoute, private customLayoutRoute: CustomLayoutRoutes ) {
  }

  ngOnInit (): void {
    this.activatedRoutes.queryParams.subscribe( params => {
      if ( params.token !== undefined ) {
        this.externalToken = params.token;
        this.isExternalToken = true;
      };
    } );
    this.errorSubscription = this.errorEvent.httpErrorMessageEvent.subscribe( message => {
      this.alert = message;
      this.isError = true;
    } );
  }

  async resetPassword () {
    await this.auth.resetPassword( this.resetForm.get( 'password' ).value, this.externalToken, this.isExternalToken );
    if ( this.isExternalToken )
      this.authroute.navigateToPasswordResetSuccessful();
    else
      this.customLayoutRoute.navigateToMainPage();
  }

  get passwordMatchError () {
    return (
      this.resetForm.getError( 'mismatch' ) &&
      this.resetForm.get( 'password' )?.touched
    );
  }

  matchValidator ( source: string, target: string ): ValidatorFn {
    return ( control: AbstractControl ): ValidationErrors | null => {
      const sourceCtrl = control.get( source );
      const targetCtrl = control.get( target );
      return sourceCtrl && targetCtrl && sourceCtrl.value !== targetCtrl.value ? { mismatch: true } : null;
    };
  }
  ngOnDestroy() {
    if (this.errorSubscription) {
      this.errorSubscription.unsubscribe();
    }
  }
}
